import { render, staticRenderFns } from "./ProductActionUpdateVariants.vue?vue&type=template&id=725bb68a&"
import script from "./ProductActionUpdateVariants.vue?vue&type=script&lang=ts&"
export * from "./ProductActionUpdateVariants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports